import PropTypes from "prop-types"
import React from "react"

import useIsTouchDevice from "src/hooks/use_is_touch_device"

const ClickablePhoneNumber = ({ phone, displayPhone }) => {
  const isTouchDevice = useIsTouchDevice()

  if (!phone || !displayPhone) return null

  if (!isTouchDevice) {
    return <span>{displayPhone}</span>
  }

  return (
    <span className="inline-flex items-center">
      <a href={`tel:${phone}`} className="text-link">
        {displayPhone}
      </a>
      <a
        href={`sms:${phone}`}
        className="ml-2 text-gray-500 hover:text-gray-700"
        aria-label="Send SMS"
      >
        <i className="fa-solid fa-message" />
      </a>
    </span>
  )
}

ClickablePhoneNumber.propTypes = {
  phone: PropTypes.string,
  displayPhone: PropTypes.string,
}

export default ClickablePhoneNumber
